import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { environment } from "../../../../environments/environment";
import { ProfileResponse } from "./profile.service";
import { LoginService } from "../login.service";
import { catchError, of } from "rxjs";
import { AlertMessageService } from "../../../feature/services/alert-msg/message.service";
import { toSignal } from "@angular/core/rxjs-interop";

export const profileResolver: ResolveFn<ProfileResponse | undefined> = (route, state) => {
  const http = inject(HttpClient);
  const authService = inject(LoginService);
  let token = authService.token();
  const _alertMessageService = inject(AlertMessageService);
  const headers = new HttpHeaders({
    Authorization: `Bearer ${token || ""}`,
  });
  const request = http.get<ProfileResponse>(`${environment.apiUrl}api/website/profile/me`, { headers }).pipe(
    catchError((err) => {
      window.location.reload();
      return of(err?.error?.status);
    }),
  );

  // const Resolve = toSignal(request);
  // // console.log("msg", Resolve());

  // if (Resolve()?.status && Resolve()!.status >= 300) {
  //   _alertMessageService.addMsg(Resolve()?.data?.toString() || "Error loading curriculum data");
  // }

  return request;
};
